var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-chunk eu-no-padding" },
    [
      _c(
        "emd-form-group",
        {
          staticClass: "eu-no-padding",
          attrs: { label: _vm.$t("invite.create.role"), required: true },
        },
        [
          _c(
            "div",
            { staticClass: "eu-mt_5" },
            _vm._l(_vm.roles, function (role, index) {
              return _c(
                "div",
                { key: index, staticClass: "eu-mb_5" },
                [
                  _c("emd-radio", {
                    staticClass: "eu-mb_2 _bold",
                    attrs: {
                      name: "radio-role-user",
                      label: role.value,
                      id: `role-type-${role.key}`,
                      value: role.key,
                      "data-testid": `input-role-type-${role.key.toLowerCase()}`,
                      size: "small",
                    },
                    model: {
                      value: _vm.permission,
                      callback: function ($$v) {
                        _vm.permission = $$v
                      },
                      expression: "permission",
                    },
                  }),
                  role.description
                    ? _c(
                        "emd-text",
                        {
                          staticClass: "eu-ml_5",
                          attrs: {
                            size: "small",
                            tag: "p",
                            "variation-color": "subtle",
                          },
                        },
                        [_vm._v(_vm._s(role.description))]
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "emd-text",
        {
          staticClass: "emd-text _color_subtle",
          attrs: { tag: "p", size: "small" },
        },
        [
          _c("em", {
            staticClass:
              "emd-text _size_small eu-mr_2 _color_success uil uil-info-circle",
          }),
          _vm._v(_vm._s(_vm.$t("role-help-info")) + " "),
          _c(
            "a",
            {
              staticClass: "emd-text _color_success",
              attrs: {
                href: "https://pagarme.helpjuice.com/p2-manual-da-dashboard/configura%C3%A7%C3%B5es-usu%C3%A1rios",
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
            [_vm._v(_vm._s(_vm.$t("about-more")))]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }